export const inspectionTabMapping = {
  L0: 1,
  L1: 2,
  L2: 3,
  L3: 4,
  DatiGenerali: 0,
  Struttura: 1,
  ElementiAccessori: 2,
  Servizi: 3,
  L0DatiProgetto: 5,
  L0AttivitaPregresse: 6,
  L0CollegamentoReteStradale: 7,
  L0Elevazione: 3,
  L0Collegamenti: 4,
  L0Impalcato: 4,
  L1InformazioneIspezione: 1,
  L1RischioFrane: 2,
  L1RischioIdraulico: 3,
  L1Elevazione: 2,
  L1Collegamenti: 3,
  L1Impalcato: 4,
  L1AspettiCritici: 5,
  // Issue #1021, punto 16 — indici degli accordion di AccordionDataL3
  // (CreateInspection/L3/config/accordionDataL3.js), stesso ordine
  // dell'array (0-based): usati per il deep-link "Approfondisci" per
  // sezione da L3RecapContent.jsx, stesso pattern di L1RischioFrane/
  // L1RischioIdraulico sopra.
  L3InformazioniGenerali: 0,
  L3DatiIdraulici: 1,
  L3Sormonto: 2,
  L3Erosione: 3,
  L3CdaIdraulica: 4,
  L3CommentiReport: 5,
};
